const courseOptions = [
  ["initial_room_3", "Sala 3 años"],
  ["initial_room_4", "Sala 4 años"],
  ["initial_room_5", "Sala 5 años"],
  ["primary_grade_1", "1° grado"],
  ["primary_grade_2", "2° grado"],
  ["primary_grade_3", "3° grado"],
  ["primary_grade_4", "4° grado"],
  ["primary_grade_5", "5° grado"],
  ["primary_grade_6", "6° grado"],
];

export const contractStudentFieldIds = new Set([
  "contract_student",
  "contract_course",
  "contract_division",
]);

export function resolveContractStudentValues(values) {
  const hasText = (value) => typeof value === "string" && value.trim().length > 0;
  const contractGuardian = hasText(values.contract_guardian) ? values.contract_guardian : "";
  const selectedCourse = courseOptions.find(([fieldId]) => values[fieldId]);
  const selectedSecondaryYear = [1, 2, 3, 4, 5, 6].find(
    (year) => values[`secondary_division_${year}`]
  );

  return {
    ...values,
    contract_clarification: hasText(values.contract_clarification)
      ? values.contract_clarification
      : contractGuardian,
    contract_student: values.student_name || "",
    contract_course:
      selectedCourse?.[1] || (selectedSecondaryYear ? `${selectedSecondaryYear}° año` : ""),
    contract_division: selectedSecondaryYear
      ? values[`secondary_division_${selectedSecondaryYear}`]
      : "",
  };
}
